import React from 'react';
import { Helmet } from 'react-helmet-async';
import useTranslation from '../hooks/useTranslation';

const SEOHead = () => {
  const { t, lang, isRTL } = useTranslation();

  const title = t('seo.title');
  const description = t('seo.description');
  const locale = lang === 'ar' ? 'ar_SA' : 'en_US';
  const canonical = 'https://orkina.com/';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Orkina Media Production',
    alternateName: 'أوركينا لإنتاج الإعلام',
    url: canonical,
    logo: `${canonical}logo-color.jpg`,
    description:
      'A full-service media and creative company specializing in TV and cinematic production, digital marketing, media training, publishing, and consulting.',
    sameAs: [],
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'SA',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: ['Arabic', 'English'],
    },
  };

  return (
    <Helmet>
      {/* Primary */}
      <html lang={lang} dir={isRTL ? 'rtl' : 'ltr'} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:locale" content={locale} />
      <meta property="og:image" content={`${canonical}logo-color.jpg`} />
      <meta property="og:site_name" content="Orkina Media Production" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${canonical}logo-color.jpg`} />

      {/* Extra SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Orkina Media Production" />
      <meta name="theme-color" content="#1a3a6b" />

      {/* JSON-LD */}
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
};

export default SEOHead;
